// extracted by mini-css-extract-plugin
export default {"item":"Book_item__zEgem","lemon":"Book_lemon__QGtD0","spanAuthor":"Book_spanAuthor__3BU2n","link":"Book_link__qdMp8"};